module.exports = __webpack_public_path__ + "img/date_0000ff.4e03e58d.png";